const stateTypes = {
  RESET_ALL_STATE: 'RESET_ALL_STATE',
  SET_EXERCISES: 'SET_EXERCISES',
  SET_MUSCLES: 'SET_MUSCLES',
  SET_SELECTED_GYM_ID: 'SET_SELECTED_GYM_ID',
  SET_LOGIN_MANAGER_ID: 'SET_LOGIN_MANAGER_ID',
  SET_LOGIN_TRAINER_ID: 'SET_LOGIN_TRAINER_ID',
  SET_LOGIN_MEMBER_ID: 'SET_LOGIN_MEMBER_ID',
  SET_GYM_DASHBOARD_DATA: 'SET_GYM_DASHBOARD_DATA',
  SET_EXERCISE: 'SET_EXERCISE',
  SET_REMOVED_EXERCISE: 'SET_REMOVED_EXERCISE',
  SET_REMOVED_GROUP: 'SET_REMOVED_GROUP',
  SET_REMOVED_PROGRAM: 'SET_REMOVED_PROGRAM',
  SET_REMOVED_TEMPLATE: 'SET_REMOVED_TEMPLATE',
  SET_GROUP: 'SET_GROUP',
  SET_MANAGERS: 'SET_MANAGERS',
  SET_TRAINERS: 'SET_TRAINERS',
  SET_MEMBERS: 'SET_MEMBERS',
  SET_REMOVED_MEMBER: 'SET_REMOVED_MEMBER',
  SET_REMOVED_TRAINER: 'SET_REMOVED_TRAINER',
  SET_GYM: 'SET_GYM',
  SET_PROGRAM: 'SET_PROGRAM',
  SET_TEMPLATE: 'SET_TEMPLATE',
  SET_REMOVED_MANAGER: 'SET_REMOVED_MANAGER',
  SET_GYM_PRODUCTS: 'SET_GYM_PRODUCTS',
};

export default stateTypes;
